import * as NetteAjax from './NetteAjax';
import * as DOMHelpers from './DOMHelpers';
import * as UnifyHeight from './UnifyHeight';
import * as URL from './Url';

export function initialize() {
    let ajaxTimeout;


    ['keyup', 'change'].forEach(function(eventType) {
        document.addEventListener(eventType, function(event) {
            if (event.target.matches('[data-filter="item"][type="text"]')) {
                let area = DOMHelpers.findParentBySelector(event.target, '[data-filter="container"]');
                clearTimeout(ajaxTimeout);
                updateState(area);
                ajaxTimeout = setTimeout(() => runFilter(area, event.target), 500);
            }
            if (event.target.matches('[data-filter="item"][type="checkbox"]')) {
                let area = DOMHelpers.findParentBySelector(event.target, '[data-filter="container"]');
                clearTimeout(ajaxTimeout);
                updateState(area);
                ajaxTimeout = setTimeout(() => runFilter(area), 500);
            }
        });
    });

    /*
    document.addEventListener('click', function(event) {
        if (event.target.matches('[data-filter="item"][type="checkbox"]')) {
            let area = DOMHelpers.findParentBySelector(event.target, '[data-filter="container"]');
            clearTimeout(ajaxTimeout);
            updateState(area);
            ajaxTimeout = setTimeout(() => runFilter(area), 500);
        }
    });
    */
}

function updateState(area)
{
    let items = area.querySelectorAll('[data-filter="item"]');

    area.state = [];

    items.forEach(function(item) {
        if(item.matches('[type="checkbox"]') && item.checked) {
            let group = item.getAttribute('data-filter-group');
            let value = item.getAttribute('data-filter-value');

            area.state.push({group: group, value: value});
        } else if(item.matches('[type="text"]')) {
            let group = item.getAttribute('data-filter-group');
            let value = item.value;

            area.state.push({group: group, value: value});
        }
    });
}

function runFilter(area, focusOn)
{
    console.log('runFilter');

    let filterName = area.getAttribute('data-filter-name');

    let settings = [];

    console.log(area.state);
    Object.entries(area.state).forEach(([, value]) => {
        let key = filterName + '[' + value.group + '][]';
        settings.push([key, value.value]);
    });

    if(area.abortControler) {
        console.log('abort');
        area.abortControler.abort();
    }

    area.abortControler = new AbortController();

    return NetteAjax.sendRequest({
        url: URL.addParameters(area.getAttribute('data-filter-url'), settings),
        signal: area.abortControler.signal
    }).then(function() {
        if(focusOn) {
            let input = document.querySelector('[data-filter-group='+focusOn.dataset.filterGroup+']');
            input.focus();
            let inputVal = input.value;
            input.value = '';
            input.value = inputVal;
        }
    });
}
